import { motion, AnimatePresence } from "framer-motion";
import { Flame } from "lucide-react";

// Animated, live-updating founding-member urgency banner.
export default function FoundingBanner({ founding, className = "" }) {
  if (!founding?.active) return null;
  const { remaining, limit, claimed, intro_price, intro_window } = founding;
  const pct = Math.min(100, Math.round((claimed / limit) * 100));
  const spotsText = remaining < limit ? `only ${remaining} of ${limit} spots left` : `${limit} founding spots left`;

  return (
    <div data-testid="founding-banner" className={`max-w-2xl mx-auto rounded-2xl bg-slate-900 text-white px-5 py-4 ${className}`}>
      <div className="flex items-center gap-3 justify-center text-center">
        <motion.span
          animate={{ scale: [1, 1.18, 1], opacity: [1, 0.7, 1] }}
          transition={{ duration: 1.6, repeat: Infinity, ease: "easeInOut" }}
          className="shrink-0"
          aria-hidden
        >
          <Flame className="w-5 h-5 text-brand" />
        </motion.span>
        <p className="text-sm font-semibold leading-snug">
          <span className="text-brand">Founding Member:</span> {intro_price}/mo for your {intro_window}, then $49/mo —{" "}
          <AnimatePresence mode="popLayout" initial={false}>
            <motion.span
              key={remaining}
              initial={{ y: -8, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: 8, opacity: 0 }}
              transition={{ duration: 0.35 }}
              className="font-bold inline-block"
              data-testid="founding-spots"
            >
              {spotsText}
            </motion.span>
          </AnimatePresence>
          <span className="text-slate-400"> (Monthly plan)</span>
        </p>
      </div>

      {/* Live countdown bar */}
      <div className="mt-3 max-w-sm mx-auto">
        <div className="h-1.5 rounded-full bg-white/10 overflow-hidden">
          <motion.div
            className="h-full rounded-full bg-brand"
            initial={{ width: 0 }}
            animate={{ width: `${pct}%` }}
            transition={{ duration: 0.9, ease: "easeOut" }}
          />
        </div>
        <div className="flex justify-between text-[10px] text-slate-400 mt-1 font-bold uppercase tracking-wide">
          <span data-testid="founding-claimed">{claimed} claimed</span>
          <span data-testid="founding-remaining">{remaining} left</span>
        </div>
      </div>
    </div>
  );
}
